/* eslint-disable */
// Forked from https://github.com/logico/lazy-youtube-embed/blob/master/src/lazy-youtube-embed.js

export default class LazyYoutubeEmbed {
    replace() {
        const loadThumb = (entries, observer) => {

            let node = entries[0].target;
            if (!node.getAttribute('loaded')) {
                let split = entries[0].target.getAttribute("href").split("/");
                let ytId = split[split.length - 1].split('?')[0];
                let thumbNode = document.createElement('div');
                let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                let quality = 'sd';
                if (connection) {
                    switch (connection.effectiveType) {
                        case '4g':
                            quality = 'maxres';
                            break;
                        case '3g':
                            quality = 'sd';
                            break;
                        default:
                            quality = 'hq';
                    }
                }

                thumbNode.style.backgroundImage = `url(https://img.youtube.com/vi/${ytId}/${quality}default.jpg)`;
                thumbNode.classList.add('thumbnail')
                node.innerHTML = '';
                node.appendChild(thumbNode);

                let playImg = document.createElement('div');
                playImg.innerHTML = '<svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#FF0000"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>';
                playImg.setAttribute('class', 'ytlight__play');
                node.appendChild(playImg);
                node.setAttribute('loaded', true)
            }
        }
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        };
        const observer = new IntersectionObserver(loadThumb, options);

        const v = document.getElementsByClassName('lazy-youtube-embed');


        for (let n = 0, len = v.length; n < len; n++) {
            const split = v[n].getAttribute("href").split("/");

            if (split.length > 0) {
                observer.observe(v[n]);
                const ytId = split[split.length - 1].split('?')[0];

                v[n].addEventListener('click', function (evt) {
                    evt.preventDefault();

                    const playerId = 'yt-' + Math.floor(Math.random() * 1e10);
                    const replacement = document.createElement('div');
                    replacement.setAttribute('id', playerId);

                    this.parentElement.replaceChild(replacement, this);

                    // 2. This code loads the IFrame Player API code asynchronously.
                    const tag = document.createElement('script');

                    // GDPR-compliant "no-cookie" usage is ensured via the "host" player option below.
                    tag.src = "https://www.youtube.com/iframe_api";
                    const firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    // 3. This function creates an <iframe> (and YouTube player)
                    //    after the API code downloads.
                    let player;
                    window.onYouTubeIframeAPIReady = function() {
                        player = new YT.Player(playerId, {
                            height: '360',
                            width: '640',
                            videoId: ytId,
                            host: 'https://www.youtube-nocookie.com',
                            playerVars: {
                                'autoplay': 1,
                            },
                            events: {
                                'onReady': onPlayerReady,
                            }
                        });
                    }

                    // 4. The API will call this function when the video player is ready.
                    function onPlayerReady(event) {
                        event.target.playVideo();
                    }
                }, false)
            }
        }
    }
}
